import matchCurrentDay from "../chronology/current/match-current-day";
import getFutureDay from "../chronology/future/get-future-day";
import getRecentDay from "../chronology/recent/get-recent-day";

// TODO: Make this work *across* seasons?? Even across volumes??
//       Check with Martijn if he wants that. Usually we stay WITHIN a season.
export default function findClosestDay(
  date,
  parentSeasonContentForSchoolLevel,
  store,
) {
  // Check if we have a day record for today.
  const currentDay = matchCurrentDay(
    date,
    parentSeasonContentForSchoolLevel,
    store,
  );

  // If the parent 'season content for school level' contains a day record
  // for the given date or a near future or recent past date, then we want
  // to use that one.
  if (currentDay) {
    return currentDay;
  }

  // As we do not have a day record for the given date, we now check
  // for future or past day records in the given season and school level.
  const futureDay = getFutureDay(date, parentSeasonContentForSchoolLevel.days);
  if (futureDay) {
    return futureDay;
  }

  const recentDay = getRecentDay(date, parentSeasonContentForSchoolLevel.days);
  if (recentDay) {
    return recentDay;
  }

  return null;
}
